<template>
  <div>
    <ValidationProvider v-slot="{ errors }" :name="label" :rules="rules">
      <b-field
        :label="label"
        :type="{ 'is-danger': errors.length > 0 }"
        :message="errors[0]"
      >
        <b-input v-show="false" v-model="item" />
      </b-field>
    </ValidationProvider>
    <div>
      <input
        class="time-input input"
        placeholder="HH"
        maxlength="2"
        @keyup="keyup"
        v-model.number="hours"
      />
      <input
        class="time-input input"
        placeholder="MM"
        maxlength="2"
        @keyup="keyup"
        v-model.number="minutes"
      />
      <input
        class="time-input input"
        placeholder="SS"
        maxlength="2"
        @keyup="keyup"
        v-model.number="seconds"
      />
      <input
        class="time-input input"
        placeholder="NNN"
        maxlength="3"
        @keyup="keyup"
        v-model.number="milliseconds"
      />
    </div>
    <p>{{ timeDisplayed }}</p>
  </div>
</template>

<script>
export default {
  inheritAttr: false,
  props: {
    label: {
      type: String,
      default: null
    },
    rules: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    }
  },
  watch: {
    value(value) {
      this.formatTime(value);
    }
  },
  mounted() {
    if (this.value) {
      this.formatTime(this.value);
    }
  },
  data() {
    return {
      item: "",
      hours: "",
      minutes: "",
      seconds: "",
      milliseconds: ""
    };
  },
  computed: {
    timeDisplayed() {
      let hours = "";
      let minutes = "";
      let seconds = "";
      let milliseconds = "";

      hours = this.hours.toString().padStart(2, "0");
      minutes = this.minutes.toString().padStart(2, "0");
      seconds = this.seconds.toString().padStart(2, "0");
      milliseconds = this.milliseconds.toString().padStart(3, "0");

      return `${hours}:${minutes}:${seconds}.${milliseconds}`;
    }
  },
  methods: {
    formatTime(ticks) {
      let milliseconds = Math.abs(parseInt(ticks % 1000, 10));
      let seconds = parseInt((ticks / 1000) % 60, 10);
      let minutes = parseInt((ticks / (1000 * 60)) % 60, 10);
      let hours = parseInt((ticks / (1000 * 60 * 60)) % 60, 10);

      this.hours = hours.toString().padStart(2, "0");
      this.minutes = minutes.toString().padStart(2, "0");
      this.seconds = seconds.toString().padStart(2, "0");
      this.milliseconds = milliseconds.toString().padStart(3, "0");
    },
    keyup() {
      if (
        this.hours.toString().trim() === "" &&
        this.minutes.toString().trim() === "" &&
        this.seconds.toString().trim() === "" &&
        this.milliseconds.toString().trim() === ""
      ) {
        this.item = null;
        this.$emit("input", null);
        return;
      }

      let score =
        this.hours.toString().trim() === ""
          ? 0
          : parseInt(this.hours, 10) * 3600000;
      score +=
        this.minutes.toString().trim() === ""
          ? 0
          : parseInt(this.minutes, 10) * 60000;
      score +=
        this.seconds.toString().trim() === ""
          ? 0
          : parseInt(this.seconds, 10) * 1000;
      score +=
        this.milliseconds.toString().trim() === ""
          ? 0
          : parseInt(this.milliseconds, 10);

      this.item = score;
      this.$emit("input", score);
    }
  }
};
</script>

<style>
.time-input {
  width: 60px;
  margin-right: 5px;
  display: inline-block;
}
</style>
